import { CommonModule } from "@angular/common";
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from "@angular/core";
import { MatDialogModule } from "@angular/material/dialog";
import { RouterModule } from "@angular/router";
import { CoreModule } from "@tylertech/core-module";
import { IntentDialogComponent } from "./components";
import { routes } from "./intentRoutes";
import { IntentService } from "./services";

const angularModules = [
    CommonModule,
];

const angularMaterialModules = [
    MatDialogModule
];

const lgdModules = [
    CoreModule
];

@NgModule({
    imports: [
        ...angularModules,
        ...angularMaterialModules,
        ...lgdModules,
        RouterModule.forChild(routes),
    ],
    declarations: [
        IntentDialogComponent
    ],
    providers: [
        IntentService
    ],
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class IntentsModule { }
